var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u2620\uFE0F Icons/notifications/info 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Client-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Details-entered",
    transform: "translate(-372.000000, -579.000000)",
    fill: "#26436F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(66.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(14.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2620\\uFE0F-Icons/notifications/info-2",
    transform: "translate(290.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C21.9938203,6.47971424 17.5202858,2.00617969 12,2 Z M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C19.9950788,16.4162379 16.4162379,19.9950788 12,20 L12,20 Z M11,6 C11,5.44771525 11.4477153,5 12,5 C12.5522847,5 13,5.44771525 13,6 C13,6.55228475 12.5522847,7 12,7 C11.7347835,7 11.4804296,6.89464316 11.2928932,6.70710678 C11.1053568,6.5195704 11,6.26521649 11,6 L11,6 Z M15,16.6153846 L15,17.5384615 C15,17.7933622 14.7964931,18 14.5454545,18 L10.4545455,18 C10.2035069,18 10,17.7933622 10,17.5384615 L10,16.6153846 C10,16.360484 10.2035069,16.1538462 10.4545455,16.1538462 L10.9090909,16.1538462 C11.1601294,16.1538462 11.3636364,15.9472083 11.3636364,15.6923077 L11.3636364,11.3076923 C11.3636364,11.0527917 11.1601294,10.8461538 10.9090909,10.8461538 L10.4545455,10.8461538 C10.2035069,10.8461538 10,10.639516 10,10.3846154 L10,9.46153846 C10,9.20663781 10.2035069,9 10.4545455,9 L13.1818182,9 C13.4328567,9 13.6363636,9.20663781 13.6363636,9.46153846 L13.6363636,15.6923077 C13.6363636,15.9472083 13.8398706,16.1538462 14.0909091,16.1538462 L14.5454545,16.1538462 C14.7964931,16.1538462 15,16.360484 15,16.6153846 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/MoreInfo.cbe39c6cd529115a52c2d23afdf2c423.svg";
export { ForwardRef as ReactComponent };